//@ts-nocheck
import { call, put } from 'redux-saga/effects';
import {
  sendVerificationTextRequest,
  sendVerificationTextSuccess,
  sendVerificationTextFailure,
} from '../reducer/smsVerificationSlice';
import { sendSmsVerification } from '../api';

interface SendVerificationTextAction {
  type: typeof sendVerificationTextRequest.type;
  payload: {
    customerIdentifiers: {
      accountId: string;
      customerId: string;
    };
    phoneInfo: {
      type: string;
      value: string;
      verificationStatus: string;
    };
    programName: string;
  };
}

// Send SMS verification saga
export function* sendSmsVerificationSaga(
  action: SendVerificationTextAction
): Generator<any, void, unknown> {
  try {
    const { customerIdentifiers, phoneInfo, programName } = action.payload;
    console.log(
      'SmsVerificationSaga: Sending verification text for phone:',
      phoneInfo.value
    );

    const requestBody = {
      customerIdentifiers,
      phoneInfo,
      programName,
    };

    const verificationResponse: any = yield call(
      sendSmsVerification,
      requestBody
    );

    console.log(
      'SmsVerificationSaga: Received verification response',
      verificationResponse ? 'with data' : 'without data'
    );

    if (verificationResponse) {
      yield put(sendVerificationTextSuccess(verificationResponse));
    } else {
      throw new Error('Invalid response format from the server');
    }
  } catch (error: any) {
    console.error(
      'SmsVerificationSaga: Error sending verification text',
      error.message || error
    );
    yield put(
      sendVerificationTextFailure(
        error.message || 'Failed to send verification text.'
      )
    );
  }
}
